import { render } from "./Comparador.vue?vue&type=template&id=31caed99&scoped=true"
import script from "./Comparador.vue?vue&type=script&lang=js"
export * from "./Comparador.vue?vue&type=script&lang=js"

import "./Comparador.vue?vue&type=style&index=0&id=31caed99&scoped=true&lang=css"

import exportComponent from "/Users/anfloman/Desktop/ComponentesAlgoritmica/TemaWordpress/tema/vuejs/ParrillaPrecios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31caed99"]])

export default __exports__